import { render, staticRenderFns } from "./CreateDistrict.vue?vue&type=template&id=58a72a88&"
import script from "./CreateDistrict.vue?vue&type=script&lang=ts&"
export * from "./CreateDistrict.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports